import { CANCEL_ALL_TASKS_WS, CANCEL_ALL_TASKS_WS_SUCCESS, CANCEL_ALL_TASKS_WS_ERROR} from './actionTypes';

export const cancelAllTasksWorkstations = ( ws, token, history) => {
    return {
        type: CANCEL_ALL_TASKS_WS,
        payload: { ws, token, history }
    }
}

export const cancelAllTasksWorkstationsSuccess = (message) => {
    return {
        type: CANCEL_ALL_TASKS_WS_SUCCESS,
        payload: {message}
    }
}

export const cancelAllTasksWorkstationsError = (ws) => {
    return {
        type: CANCEL_ALL_TASKS_WS_ERROR,
        payload: ws
    }
}
